(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["product-nutrients"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    // See all toggle for nutrients sections
    const readmoreElements = document.querySelectorAll('div[data-readmore]');

    readmoreElements.forEach(function (element) {
      // Hide the element initially
      element.style.display = 'none';

      // Get open text or use default
      let openText = element.dataset.seeAll || 'See All';

      // Create toggle button
      const toggleButton = document.createElement('a');
      toggleButton.setAttribute('data-readmore-toggle', '');
      toggleButton.setAttribute('href', '#');
      toggleButton.className = 'readmore-toggle';
      toggleButton.innerHTML = '<span>' + openText + '</span>';

      // Insert button before the readmore element
      element.parentNode.insertBefore(toggleButton, element);
    });

    // Add click handlers to toggle buttons
    document.addEventListener('click', function (e) {
      const toggleButton = e.target.closest('[data-readmore-toggle]');
      if (!toggleButton) return;

      e.preventDefault();

      // Toggle active class
      toggleButton.classList.toggle('active');

      // Find the associated readmore div
      const readmoreDiv =
        toggleButton.nextElementSibling && toggleButton.nextElementSibling.hasAttribute('data-readmore')
          ? toggleButton.nextElementSibling
          : toggleButton.previousElementSibling;

      if (!readmoreDiv) return;

      // Get text values
      let openText = readmoreDiv.dataset.openText || 'See All';
      let closeText = readmoreDiv.dataset.closeText || 'Close';

      // Get current button text
      const currentText = toggleButton.querySelector('span').textContent.trim();

      if (currentText === openText) {
        // Show content
        toggleButton.innerHTML = '<span>' + closeText + '</span>';
        readmoreDiv.style.display = 'block';
        // Move button after the content
        readmoreDiv.parentNode.insertBefore(toggleButton, readmoreDiv.nextSibling);
      } else {
        // Hide content
        toggleButton.innerHTML = '<span>' + openText + '</span>';
        readmoreDiv.style.display = 'none';
        // Move button before the content
        readmoreDiv.parentNode.insertBefore(toggleButton, readmoreDiv);
      }
    });
  });

  } catch(e) { console.error(e); }
})();
})();
